import types from 'actions/types'
import { combineReducers } from 'redux'

// Note: ids stored separately to aid in state hydration

const ids = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_LOAD_QUOTE_SUCCESS:
      let ret = [ ...state ]
      ret = ret.filter(id => id != action.data.id)
      ret.unshift(action.data.id)
      return ret

    default: return state
  }
}

const data = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_LOAD_QUOTE_SUCCESS:
      let ret = [ ...state ]
      ret = ret.filter(order => order.id != action.data.id)
      ret.unshift(action.data)
      return ret

    case types.QUOTING_QUOTE_CHANGE_ORDER_STATUS_SUCCESS:
    case types.QUOTING_QUOTE_SAVE_SUCCESS: {
      if (state == null) return null
      const updated = action.data.result
      return state.map(d => d.id == updated.id ? updated : d)
    }


    default: return state
  }
}

export default combineReducers({
  ids,
  data,
})
